<template>
    <div id="integrationsPage">
        <h4 class="group-title">eCommerce Platforms</h4>
        <!--select id="selectPlatform" v-model="page" class="form-control">
            <option value="bcapp">BigCommerce</option>
            <option value="wordpress">WordPress</option>
        </select-->
        <p class="description">Manage connections with eCommerce platforms.</p>

        <BigCommerceApp />
        <WordpressPlugin />
    </div>
</template>

<script>
import appConfig from "@/app.config";
import BigCommerceApp from "@/components/settings/integrations/bigCommerceApp";
import WordpressPlugin from "@/components/settings/integrations/wordpressPlugin";

export default {
    name: "AdminPage",
    page: {
        title: "admin",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: {
        BigCommerceApp,
        WordpressPlugin,
    },
    data() {
        return {
            page: 'bcapp',
        };
    },
}
</script>

<style lang="scss" scoped>
#integrationsPage
{
    position: relative;
}
#selectPlatform
{
    width: 24em;
    display: inline-block;
    margin-bottom: .5em;
    position: absolute;
    right: 0;
    top: 0;
}
</style>